@if (isOpen() && content()) {
  <div class="row layout-overlay flex" [ngStyle]="content().typeSpecific.style.descriptionBackground">
    <div class="layout-description">
      @if (content() && content().description && content().typeSpecific.style.description.enabled) {
        <div
          [ngStyle]="content().typeSpecific.style.description | responsiveStyle"
          style="word-break: break-word"
          [content]="content()"
          [deltaContent]="content().description"
          [item]="config().data ? config().data[0] : undefined"
        ></div>
      }
    </div>

    <div class="layout-export flex flex-col">
      <div class="export-button cursor-pointer" title="Close" style="margin-top: auto" (click)="isOpen.set(false)"><i class="icon icon-cancel-1"></i></div>
    </div>
  </div>
}
